import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

import SubmissionDetailStage from "composer/views/retriever/SubmissionDetailStage.jsx"
import CompareAnswerDialog from "composer/views/retriever/CompareAnswerDialog.jsx";
import StatisticsDialog from "composer/views/retriever/StatisticsDialog.jsx"

class SubmissionDetail extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      submissionId: 0,
      stageList: [],
      currentAnswerData: null,
      compareAnswerList: [],
    };
    autoBind(this);

    this.refresh();
  }

  refresh() {
    if (this.state.submissionId > 0) {
      this.setState({
        stageList: [],
      });
      this.state.stageList = [];
      this.props.root.refs.API.request("get_answers_by_submission_id", {submission_id: this.state.submissionId}, this.getAnswersOK, this.getAnswersFailed);
    }
  }

  getAnswersOK(res) {
    this.setState({
      stageList: res.body['result']['stage_list'],
    });
    this.state.stageList = res.body['result']['stage_list'];
  }

  getAnswersFailed(err) {
    console.log("get answers failed " + err);
  }

  getAllAnswers(answerData) {
    this.setState({ currentAnswerData: answerData });

    let requestObj = {};
    let submissionList = this.props.parent.state.submissionList;
    let submissionIDList = [];
    for (let i = 0; i < submissionList.length; i++) {
      submissionIDList.push(submissionList[i].id);
    }
    requestObj['submission_id_list'] = submissionIDList;
    this.props.root.refs.API.request("get_all_answers_in_submission_list", requestObj, this.getAllAnswerOK, this.getAllAnswerFailed);
  }

  getAllAnswerOK (res) {
    this.setState({
      compareAnswerList: res.body['result']['submission_list'],
    });
    this.state.compareAnswerList = res.body['result']['submission_list'];
    this.getStatistics();
  }

  getAllAnswerFailed(err) {

  }

  getStatistics() {
    let mcAnsArray = [0, 0, 0, 0];

    this.state.compareAnswerList.map( (row, i) => {
      let targetAnswerData;
      let stage_list = row['stage_list'];
      for (let i = 0; i < stage_list.length; i++) {
        let stage = stage_list[i];
        let answer_list = stage['answer_list'];
        for (let j = 0; j < answer_list.length; j++) {
          let answer = answer_list[j];
          if (answer['playback_id'] == this.state.currentAnswerData['playback_id']) {
            targetAnswerData = answer;
            mcAnsArray[targetAnswerData['answer']] = mcAnsArray[targetAnswerData['answer']] + 1;
          }
        }
      }
    })

    let chart = [{name: 'A', Attempts: mcAnsArray[0]}, {name: 'B', Attempts: mcAnsArray[1]}, {name: 'C', Attempts: mcAnsArray[2]}, {name: 'D', Attempts: mcAnsArray[3]},];
    this.refs.statisticsDialog.setState({
      barChartData: chart,
    });
    this.refs.statisticsDialog.state.barChartData = chart;
  }

  render() {
    return (
      <div style={{maxHeight:this.props.maxHeight, overflow:'auto'}}>
        <CompareAnswerDialog root={this.props.root} parent={this} ref="compareAnswerDialog"/>
        <StatisticsDialog root={this.props.root} parent={this} ref="statisticsDialog"/>

        {this.state.stageList.map( (row, i) => {
          return (
            <SubmissionDetailStage parent={this} root={this.props.root}
              stageData={row['stage_detail']}
              answerDataList={row['answer_list']}
              key={row['stage_detail']['id']}
            />
          );
        })}
      </div>
    )
  }
}

export default SubmissionDetail;
